/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.3.1(bac26893f27c9ed9e67951f467120ce782f58226)
 * Released under the MIT license
 * https://github.com/Microsoft/vscode/blob/master/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/languages/less/common/lessWorker.nls.fr", {
	"vs/languages/less/common/services/intelliSense": [
		"L\'URL encode une chaîne",
		"contenu de chaîne d\'échappement",
		"remplacement de chaîne",
		"supprime ou modifie l\'unité d\'une dimension",
		"analyse une chaîne pour obtenir une couleur",
		"convertit des nombres d\'un type à un autre",
		"intègre une ressource et revient à `url()`",
		"retourne le nombre d\'éléments dans une liste de valeurs",
		"retourne une valeur à la position spécifiée dans la liste",
		"valeur absolue d\'un nombre",
		"arccosinus - inverse de la fonction cosinus",
		"arcsinus - inverse de la fonction sinus",
		"arrondit à l\'entier supérieur",
		"fonction cosinus",
		"arrondit à l\'entier inférieur",
		"convertit en pourcentage, par ex. 0,5 > 50 %",
		"arrondit un nombre à un nombre de décimales",
		"calcule la racine carrée d\'un nombre",
		"fonction sinus",
		"fonction tangente",
		"arctangente - inverse de la fonction tangente",
		"retourne pi",
		"premier argument élevé à la puissance du second argument",
		"premier argument coefficient second argument",
		"retourne la ou les valeurs les plus faibles",
		"retourne la ou les valeurs les plus faibles",
		"crée un #AARRVVBB",
		"crée une couleur",
		"crée une couleur",
		"crée une couleur",
		"crée une couleur",
		"retourne le canal `teinte` de `@color` dans l\'espace TSL",
		"retourne le canal `saturation` de `@color` dans l\'espace TSL",
		"retourne le canal `luminosité` de `@color` dans l\'espace TSL",
		"retourne le canal `teinte` de `@color` dans l\'espace TSV",
		"retourne le canal `saturation` de `@color` dans l\'espace TSV",
		"retourne le canal `valeur` de `@color` dans l\'espace TSV",
		"retourne le canal `rouge` de `@color`",
		"retourne le canal `vert` de `@color`",
		"retourne le canal `bleu` de `@color`",
		"retourne le canal `alpha` de `@color`",
		"retourne la valeur `luma` (luminosité perçue) de `@color`",
		"retourne \'@color\' à 10 % de points plus saturés",
		"retourne \'@color\' à 10 % de points moins saturés",
		"retourne \'@color\' à 10 % de points plus clairs",
		"retourne \'@color\' à 10 % de points plus sombres",
		"retourne \'@color\' à 10 % de points moins transparents",
		"retourne \'@color\' à 10 % de points plus transparents",
		"retourne `@color` avec 50 % de transparence",
		"retourne `@color` avec 10 degrés de teinte en plus",
		"retourne un mélange de `@color1` et de `@color2`",
		"retourne une couleur grise désaturée à 100 %",
		"retourne `@darkcolor` si `@color1 is> 43% luma` sinon retourne `@lightcolor`, voir remarques",
	]
});